
import styled from "styled-components";
import { system } from "styled-system";

export default styled.svg.withConfig({
  shouldForwardProp: (prop) => true,
})`
  ${system({
    fill: {
      property: "fill",
      scale: "colors",
    }
  })}
`;
